import { flashBagSuccess } from '@tools/flashbag';
import createCenteredPopupWindow from '@elements/window-center';
import translation from '@tools/translations/translations';
import ExtendableButton from '@atoms/extendable-button';

function copyInputValue(el) {
  navigator.clipboard.writeText(el.value).then(() => {
    flashBagSuccess(translation().messages['offer.link.copied']);
  });
}

export default function (shareButtonContainer) {
  shareButtonContainer.querySelectorAll('li > input[aria-hidden]').forEach((el) => {
    el.parentElement.addEventListener('click', () => copyInputValue(el));
  });

  shareButtonContainer.querySelectorAll('.social-network-link').forEach((el) => {
    el.addEventListener('click', () => createCenteredPopupWindow(el.dataset.href, '', 950, 500));
  });

  ExtendableButton(shareButtonContainer.querySelector('a'), shareButtonContainer.querySelector('ul'));
}
